@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../constants/spacing.module.less';

@font-size: 14px;
@input-height: 32px;

.drawer-fulfillment-smartfill-banner {
  margin: @space-24 @space-32 @space-0;
}

.drawer-fulfillment-configuration {
  padding: 15px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  row-gap: 10px;
  font-size: @font-size;

  > .label {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
    text-align: right;
    max-width: 100px;
    div[class^='pickup-relay-info-icon'] {
      top: 3px;
    }
    line-height: 1.2;

    &.error {
      color: @orders-drawer--single-csw--error--text-color;
    }
  }

  .lable-with-helper-text {
    height: calc(100% - 24px);
  }

  .aligned-with-input {
    height: @input-height;
    align-items: flex-start;
  }

  .center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .weight {
    display: flex;
    min-width: 0;

    .weight-input {
      width: 100px;
    }

    .scale {
      width: 78px;
    }
  }

  .size-and-weight-container {
    grid-column: ~'2 / 4';
    padding-right: 5px;
  }

  .size-input {
    width: 75px;
  }

  .requested-service {
    * {
      font-size: @font-size;
    }
  }

  .multi-package {
    display: flex;
    font-size: 18px;
  }

  .error-container {
    grid-column: 1 / span 3;
    justify-content: flex-start;
  }

  .rejected-banner {
    grid-column: 1 / span 3;
    display: flex;
    width: 100%;
  }

  .package-content-description-info-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    .info-icon {
      height: 16px;
      width: 16px;
      color: var(--default--icon--fill-color--1);
    }
  }
}

.full-width-content {
  grid-column: 1 / span 3;
}

.insurance-promo-layout {
  grid-column: 1 / span 2;
}

.insurance-promo-overrides {
  padding: 0 @space-8 @space-8;
}
